import React, { Component } from 'react';
import {connect} from 'react-redux';
import ResampleConfigComponent from './ResampleConfigComponent.js';
import Dropdown from 'react-dropdown'
import ReactBootstrapSlider from 'react-bootstrap-slider';
import '../../ExternalInstrument.scss';

class ExternalInstrumentComponent extends Component {
    constructor(props) {
        super(props);

        let channel = this.props.track.midiChannel === undefined ? 'all' :
            this.props.track.midiChannel;
        this.state = {
            midiChannel: channel,
        }
    }
    
    onSelectMidiChannel(channel) {
        this.state.midiChannel = channel.value;
        this.props.track.midiChannel = channel.value;
        this.setState(this.state);
    }

    updateLatency(x) {
        this.props.track.latency = x;
        this.setState(this.state);
    }

    onClick() {
        if (this.props.planeMapping) {
            this.props.planeMapping.randomlyMapParameters(
                this.props.track,
                undefined,
                this.props.track.ccParameters);
        }
    }

    render() {
        let midiEngine = this.props.track.sequencerEngine.midi;
        return (
            <div
              onClick={() => this.onClick()}
              className={this.props.planeMapping ? "instrument plane-mapping external-instrument" : "instrument external-instrument"}>
              <div className="external-instrument-header">
                External Instrument
              </div>
              <div className="inner-instrument">
              <div className="midi-channel-container">
                <div className="midi-channel">Channel: </div>
                <Dropdown
                  className='midi-input-dropdown'
                  controlClassName='midi-input-control-dropdown'
                  options={midiChannelOptions}
                  onChange={(o) => this.onSelectMidiChannel(o)}
                  value={getMidiChannelOption(this.state.midiChannel)}
                  placeholder="Midi Channel" />
              </div>
                
              <div className="midi-outputs-container"> 
                {midiEngine.getTrackedOutputs().map(
                    output =>
                <MidiOutput track={this.props.track} output={output}/>)}
            </div>
                <div>
                <div>Latency: {this.props.track.latency} ms</div>
                  <ReactBootstrapSlider
                    value={this.props.track.latency}
                    change={(e) => this.updateLatency(e.target.value)}
                    step={1}
                    max={100}
                    min={1}
                    orientation="horizontal"
                    reversed={false}
                    />
                </div>
                <ResampleConfigComponent sequencerEngine={this.props.track.sequencerEngine}/>
              </div>
           </div>
        );
        
    }
}

class MidiOutput extends Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        let outputs = this.props.track.getMidiOutputs();
        return outputs.has(this.props.output);
    }

    onClickMidiOutput() {
        if (this.isEnabled()) {
            this.props.track.deleteMidiOutput(this.props.output);
        } else {
            this.props.track.addMidiOutput(this.props.output);
        }

        this.setState(this.state);
    }

    render() {
        let enabled = this.isEnabled();
        return (
            <div className={this.isEnabled() ? "midi-option enabled" : "midi-option"} onClick={() => this.onClickMidiOutput()}>
              {this.props.output.name}
            </div>
        );
    }
}

const midiChannelOptions = [
    {value: 'all', label:'All'},
    {value: 1, label:'1'},
    {value: 2, label:'2'},
    {value: 3, label:'3'},
    {value: 4, label:'4'},
    {value: 5, label:'5'},
    {value: 6, label:'6'},
    {value: 7, label:'7'},
    {value: 8, label:'8'},
    {value: 9, label:'9'},
    {value: 10, label:'10'},
    {value: 11, label:'11'},
    {value: 12, label:'12'},
]

function getMidiChannelOption(value) {
    for (var i=0; i < midiChannelOptions.length; i++) {
        if (midiChannelOptions[i].value == value) {
            return midiChannelOptions[i];
        }
    }
    return null;
}

const mapStateToProps = (state) => {
    return {
        planeMapping: state.effects.planeMapping,
    }
};


export default connect(mapStateToProps, null)(ExternalInstrumentComponent);
